// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"fe5b47b0","453":"28902090","796":"7f909b6d"}[chunkId] + ".chunk.js";
};